import styled from "styled-components";

import { ScheduleSessionPropsStyled as Props } from "./ScheduleSession.types";
import CONSTANTS from "config/constants";

const { tablet } = CONSTANTS.BREAKPOINTS;

const ScheduleSessionStyled = styled.button<Props>`
  background-color: ${props => props.backgroundColor};
  border: 0.2rem solid ${props => props.borderColor};
  border-radius: 0.8rem;
  padding: 0.8rem 1.6rem;
  height: 4rem;
  margin-right: 1.6rem;
  margin-top: 1.6rem;
  justify-content: center;
  align-items: center;
  cursor: ${props =>
    props.unavailable || props.depleted ? "not-allowed" : "pointer"};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .ScheduleSession {
    &__loading {
      svg {
        height: 2rem;
        width: 2rem;
        animation: rotate 0.6s linear infinite;
      }
    }

    &__text {
      background-color: unset;
      padding: 0;
      border: none;
      box-shadow: none;
      font-size: 1.6rem;
      font-weight: 600;
      color: ${props => props.customTextStyle};

      @media (max-width: ${tablet}px) {
        font-size: 1.4rem;
      }
    }
  }
`;

export default ScheduleSessionStyled;
